{
  "form": {
    "input_placeholder": "একটি কাজ যোগ করুন…",
    "parseWithAi_aria": "AI দিয়ে কাজ বিশ্লেষণ করুন",
    "parseWithAi_title": "AI দিয়ে পরিষ্কার করুন ও অগ্রাধিকার নির্ধারণ করুন",
    "priorityLabel_aria": "কাজের অগ্রাধিকার",
    "add": "যোগ করুন",
    "signInForAi": "AI বৈশিষ্ট্য ব্যবহার করতে সাইন ইন করুন।",
    "aiUnavailable": "AI অনুপলব্ধ। আবার চেষ্টা করুন।",
    "saveTo": "সংরক্ষণ করুন",
    "saveTo_aria": "{{list}}-এ সংরক্ষণ করুন",
    "saveToSynced_aria": "{{list}}-এ সংরক্ষণ করুন, {{provider}}",
    "addedTo": "{{list}}-এ যোগ হয়েছে",
    "addedToSynced": "{{list}}-এ যোগ হয়েছে · {{provider}}",
    "show": "দেখুন"
  },
  "priority": {
    "Critical": "জরুরি",
    "High": "উচ্চ",
    "Medium": "মাঝারি",
    "Low": "নিম্ন"
  },
  "item": {
    "edit_aria": "কাজ সম্পাদনা করুন",
    "delete_aria": "কাজ মুছুন",
    "addStep": "একটি ধাপ যোগ করুন",
    "addStep_placeholder": "একটি ধাপ যোগ করুন…",
    "addStep_aria": "{{task}}-এ একটি ধাপ যোগ করুন",
    "steps_group_aria": "{{task}}-এর ধাপ",
    "steps_progress_aria": "{{count}}টির মধ্যে {{done}}টি ধাপ সম্পন্ন",
    "completeSteps_aria": "{{task}}। {{count}}টি খোলা ধাপও সম্পন্ন হবে"
  },
  "list": {
    "title": "কাজ",
    "newListFallback": "নতুন তালিকা",
    "completedMeta": "{{total}}টির মধ্যে {{completed}}টি সম্পন্ন",
    "deleteConfirm": "\"{{name}}\" মুছবেন?",
    "rename_title": "নাম পরিবর্তন",
    "deleteList_title": "তালিকা মুছুন",
    "newListName_placeholder": "তালিকার নাম…",
    "newList": "নতুন তালিকা",
    "done": "সম্পন্ন",
    "emptyTitle": "এখনও কোনো কাজ নেই",
    "emptySubtitle": "শুরু করতে নিচে একটি যোগ করুন।",
    "noFilterMatch": "এই ফিল্টারের সাথে কোনো কাজ মেলে না।",
    "createIn": "যেখানে তৈরি করবেন",
    "inDestination": "{{destination}}-এ",
    "createIn_aria": "{{destination}}-এ তৈরি করুন",
    "createInAccount_aria": "{{destination}}-এ তৈরি করুন, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "{{destination}}-এ তৈরি হচ্ছে…",
    "createFailed": "{{destination}}-এ “{{name}}” তৈরি করা যায়নি।",
    "createLimit": "{{destination}}-এর তালিকার সীমা পূর্ণ হয়ে গেছে।",
    "keepInRhemn": "Rhemn-এ রাখুন"
  },
  "filter": {
    "label": "ফিল্টার",
    "all": "সব"
  },
  "voice": {
    "mic_aria": "কণ্ঠে কাজ যোগ করুন",
    "mic_title": "আপনার কাজগুলো বলুন — অগ্রাধিকার ও সময় অনুযায়ী সাজানো হবে",
    "stop_aria": "থামুন ও কাজ সাজান",
    "recording": "রেকর্ড হচ্ছে",
    "sorting": "আপনার কাজ সাজানো হচ্ছে…",
    "stripTitle": "শোনা কাজসমূহ",
    "stripCount": "{{total}}-এর মধ্যে {{checked}}",
    "discard": "বাতিল",
    "addN": "{{count}}টি যোগ করুন",
    "addZero": "যোগ করুন",
    "adding": "যোগ হচ্ছে…",
    "parseFallback": "সাজানো গেল না — আপনার কথা বাক্সে আছে।",
    "nothingHeard": "শোনা যায়নি — আবার চেষ্টা করুন।",
    "micDenied": "মাইক্রোফোন বন্ধ — সেটিংসে অনুমতি দিন।",
    "gateBody": "আপনার কাজ বলুন — অগ্রাধিকার ও নামাজের সময় অনুযায়ী সাজানো। Pro-এর সাথে।",
    "listen_aria": "শুনছে — আপনার কাজ বলুন"
  }
}
